import React from 'react';
import MetaTags from 'react-meta-tags';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './HomeHeaderShop.scss';

import usePageLoadEvent from '../../../CustomHooks/usePageLoadEvent';

import { openNewCircleModal } from '../../../Actions/UIActions';

const HomeHeaderShop = props => {
  const seo_header = 'ShopMy | Curated By the Obsessed, Not the Algorithm.';
  const seo_description = "Shop the recommendations of the world's most trusted tastemakers.";

  usePageLoadEvent('Home - Shop - Page View');

  const [isVideoLoaded, setIsVideoLoaded] = React.useState(false);
  const handleVideoLoaded = () => {
    setIsVideoLoaded(true);
  };

  const clickCreateCircle = () => {
    props.openNewCircleModal({
      params: {
        panel: 'intro'
      },
      source: 'Home Header'
    });
  };

  return (
    <div className='home-header-shop-outer-container'>
      <MetaTags>
        <title>{seo_header}</title>
        <meta property='og:title' content={seo_header} />
        <meta property='description' content={seo_description} />
        <meta property='og:description' content={seo_description} />
      </MetaTags>
      <video className='cover-video' autoPlay muted loop playsInline onLoadedData={handleVideoLoaded}>
        <source src='https://static.shopmy.us/Home/Home_Shop.mp4' type='video/mp4' />
      </video>
      <img
        className={cn('cover-image', { 'is-video-loaded': isVideoLoaded })}
        src='https://static.shopmy.us/Home/Home_Shop.jpg'
        alt='World Leading Curators'
      />
      <div className='home-header-shop-inner-container'>
        <div className='main-container'>
          <div className='title-container'>
            <h1 className='title'>
              Curated by the <i>obsessed</i>,
              <br />
              not the algorithm.
            </h1>
            <h2 className='subtitle'>Shop the recommendations of the world's most trusted curators.</h2>
          </div>
          <div className='actions-container'>
            <div onClick={props.scrollToNextSection} className='action'>
              Shop Curators
            </div>
            <div onClick={clickCreateCircle} className='action'>
              Create a Circle
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

HomeHeaderShop.propTypes = {
  user: PropTypes.object.isRequired,
  scrollToNextSection: PropTypes.func.isRequired,
  openNewCircleModal: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, { openNewCircleModal })(HomeHeaderShop);
